
import React, { useEffect, useState } from "react";
import { Card, Button, Col, Row, Form } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import ConfirmOnExit from "../../../components/confirmOnExit/ConfirmOnExit";

function ConsumableFullEntryViewReportForm() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    material_group: state,
  });
  const [showDialog, setShowDialog] = useState(false);
  const [form] = Form.useForm();

  const handleClickBack = () => {
    navigate("/consumableEntryNewReport");
  };

  const highlightMismatch = (consumable, sales) => {
    if (consumable !== sales) {
      return { color: "#f44336", fontWeight: "bold" }; // Highlight in red
    }
    return {};
  };

  useEffect(() => {
    if (state?.data) {
      setFormData(state.data);
    }
  }, [state?.data, state?.outlet_id]);

  return (
    <>
      <Card>
        <ConfirmOnExit showModel={showDialog} />
        <Row style={{ justifyContent: "center" }}>
          <Col span={24}>
            <Form
              onFieldsChange={() => setShowDialog(true)}
              name="basic"
              form={form}
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              autoComplete="off"
            >
              <Row gutter={[15, 0]}>
                <Col span={24}>
                  {formData.material_group.salesData?.data ? (
                    Object.entries(formData.material_group.salesData.data)
                      .filter(([, outlet]) => outlet.outlet_id === state.outlet_id)
                      .map(([ outlet], i) => (
                        <div
                          key={i}
                          style={{
                            width: "850px",
                            borderRadius: "8px",
                            marginBottom: "16px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              padding: "8px",
                              flexDirection: "column",
                              background: "#e8f5e9",
                              borderRadius: "8px",
                              marginBottom: "12px",
                            }}
                          >
                            <h3
                              style={{
                                color: "#1b5e20",
                                fontWeight: "bold",
                                margin: "0 0 8px",
                              }}
                            >
                              {outlet.outlet_name} ({outlet.outlet_code})
                            </h3>
                          </div>
                          {outlet.material_group_sales?.length > 0 ? (
                            <table
                              style={{
                                width: "100%",
                                borderCollapse: "collapse",
                                marginBottom: "8px",
                              }}
                            >
                              <thead>
                                <tr style={{ background: "#f0f0f0" }}>
                                  <th
                                    style={{ padding: "8px", border: "1px solid #ddd" }}
                                  >
                                    Category
                                  </th>
                                  <th
                                    style={{ padding: "8px", border: "1px solid #ddd" }}
                                  >
                                    Consumable
                                  </th>
                                  <th
                                    style={{ padding: "8px", border: "1px solid #ddd" }}
                                  >
                                    Sales
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {outlet.material_group_sales.map((cat, j) => {
                                  const matchedConsumable = formData.material_group?.material_group.find(
                                    (item) => item.category_name === cat.category_name
                                  );

                                  const qty_consumable =
                                    matchedConsumable?.qty_consumable || "-";

                                  return (
                                    <tr key={j}>
                                      <td
                                        style={{
                                          padding: "8px",
                                          border: "1px solid #ddd",
                                        }}
                                      >
                                        {cat.category_name}
                                      </td>
                                      <td
                                        style={{
                                          padding: "8px",
                                          border: "1px solid #ddd",
                                          ...highlightMismatch(
                                            qty_consumable,
                                            cat.qty_sales
                                          ),
                                        }}
                                      >
                                        {qty_consumable}
                                      </td>
                                      <td
                                        style={{
                                          padding: "8px",
                                          border: "1px solid #ddd",
                                          ...highlightMismatch(
                                            qty_consumable,
                                            cat.qty_sales
                                          ),
                                        }}
                                      >
                                        {cat.qty_sales || "-"}
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          ) : (
                            <p
                              style={{
                                margin: "8px 0",
                                color: "#f44336",
                              }}
                            >
                              No Sales Data
                            </p>
                          )}
                        </div>
                      ))
                  ) : (
                    "No Data"
                  )}
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </Card>

      <Row
        gutter={[15, 15]}
        style={{ justifyContent: "center", marginTop: "20px" }}
      >
        <Col span={12}>
          <Form.Item>
            <Button onClick={handleClickBack}>Back</Button>
          </Form.Item>
        </Col>
      </Row>
    </>
  );
}

export default ConsumableFullEntryViewReportForm;
